import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      ...CommonFonts.darkFont16,
      fontWeight: '600',
    },
    checkBoxLabel: {
      '& .MuiFormControlLabel-label': {
        ...CommonFonts.darkFont16,
      },
    },
    boxInput: {
      marginTop: theme.spacing(10),
    },
  })
);

export default useStyles;
